import { useDrag } from 'react-dnd'
import { ItemTypes } from '../../ItemTypes.js'
import {format, register} from "timeago.js"
import { useContext, useEffect, useRef, useState } from 'react';
import ContextMenu from '../contextmenu/ContextMenu.jsx';
import { AuthContext } from "../../context/AuthContext";

export const MissionItem = function MissionItem({mission, selectedMission, setSelectedMission, isMissionDragging, setMissionDragging }) {
    const de = require("timeago.js/lib/lang/de").default;
    register("de", de);
    const [missionstate,setMissionstate] = useState("new")
    const contextMenuRef = useRef(null)
    const {user:currentUser, dispatch} = useContext(AuthContext)
    const [contextMenu, setContextMenu] = useState({
        x: 0,
        y: 0
    }, /*toggled = false*/)

    const missionClickHandler = async (e) => {
        e.preventDefault();
        console.log(mission._id)
        setSelectedMission(mission);
    }

    const handleContextMenu = async (e, rightClickedMission) => {
        e.preventDefault();
        const contextMenuAttr = contextMenuRef.current.getBoundingClientRect()

        const isLeft = e.clientX < window?.innerWidth / 2

        let x
        let y = e.clientY

        if(isLeft) {
            x = e.clientX
        } else {
            x = e.clientX - contextMenuAttr.width
        }

        resetContextMenu()

        setContextMenu({
            position: {
                x,
                y,
            },
            isToggled: true
        })
        setSelectedMission(rightClickedMission)
    }

    function resetContextMenu() {
        setContextMenu({
            position: {
                x: 0,
                y: 0
            },
            toggled: false
        })
    }

    useEffect(() => {
        function handler(e) {
            if(contextMenuRef.current) {
                if(!contextMenuRef.current.contains(e.target)) {
                    resetContextMenu()
                }
            }
        }

        document.addEventListener('click', handler)

        return () => {
            document.removeEventListener('click', handler)
        }
    })

    const [{ isDragging }, drag] = useDrag(() => ({
        type: ItemTypes.MISSION,
        item: { mission },
        end: (item, monitor) => {
            const dropResult = monitor.getDropResult()
            if(item && dropResult) {
                console.log("ok dropped")
            }
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
            handlerID: monitor.getHandlerId(),
        }),
    }))
    
    return (
        <div className={`missionListItem ${missionstate}`} 
        onClick={missionClickHandler} ref={drag} data-testid={'mission'}
        onContextMenu={(e) => handleContextMenu(e, mission)}>
        <div className="keywordtime">
          <div className="keyword">{mission.keyword}</div>
          <div className="timeago">{format(mission.createdAt, 'de')}</div>
        </div>
        <div className="text">{mission.rawtext}</div>
        <div className="citysubcity">
          <div className="city">{mission.city}</div>
          <div className="subcity">{mission.subcity}</div>
        </div>
        <ContextMenu 
            contextMenuRef={contextMenuRef}
            isToggled={contextMenu.isToggled}
            positionx={contextMenu.positionx}
            positiony={contextMenu.positiony}
            buttons={[
                {
                    text: "Do Something",
                    icon: "😊",
                    onClick: () => alert("Hallo"),
                    isSpacer: false,
                },
                {
                    text: "Do something else",
                    icon: "😛",
                    onClick: () => alert("WOW"),
                    isSpacer: false,
                },
            ]}
            />
      </div>
    )
}